import { render, staticRenderFns } from "./b2bcontractpurchase-customer.vue?vue&type=template&id=589119de&scoped=true&"
import script from "./b2bcontractpurchase-customer.vue?vue&type=script&lang=js&"
export * from "./b2bcontractpurchase-customer.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./b2bcontractpurchase-customer.vue?vue&type=style&index=1&id=589119de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589119de",
  null
  
)

export default component.exports